<script>
import Stickyfill from '../polyfills/stickyFill';
export default {
    props: ['isInView'],
    data: () => ({
        hashValue: '',
        previousHash: '',
        isMainAccordionOpen: false,
        activeItem: false,
        timeout: undefined
    }),
    computed: {
        hash() {
            return this.hashValue ? this.hashValue.split('#')[1] : '';
        },
        title() {
            const hashSplit = this.hash.split('-').map(val => val.charAt(0).toUpperCase() + val.slice(1));
            return hashSplit.join(' ') || 'Explore This Community';
        }
    },
    mounted() {
        Stickyfill.addOne(this.$refs.communityNav);
        this.$eventsBus.$on('nav-scroll', this.handleScroll);
        this.checkInitHash();
        // window.addEventListener('hashChange', this.handleHashchange, false);
    },
    beforeDestroy() {
        if (this.timeout) {
            window.clearTimeout(this.timeout);
        }
        Stickyfill.removeOne(this.$refs.communityNav);
        this.$eventsBus.$off('nav-scroll', this.handleScroll);
        window.removeEventListener('hashchange', this.handleHashchange);
    },
    methods: {
        loadedHash() {
            this.hashValue = window.location.hash;
            this.scrollTo(this.hash);
            window.clearTimeout(this.timeout);
        },
        checkInitHash() {
            // If a hash exists
            if (window.location.hash) {
                // Set a timeout before scrolling so correct dimensions
                // and positions are calculated
                this.timeout = window.setTimeout(this.loadedHash, 500);
            }
        },
        getHeaderOffset() {
            const header = document.querySelector('.main-nav');
            return !header ? 0 : header.getBoundingClientRect().height;
        },
        getNavOffset() {
            const nav = document.querySelector('.community-nav');
            return !nav ? 0 : nav.getBoundingClientRect().height;
        },
        handleScrollComplete() {
            this.$eventsBus.$on('nav-scroll', this.handleScroll);
        },
        scrollTo(hash) {
            const id = `#${hash}`;
            const elem = document.getElementById(hash);
            this.$eventsBus.$off('nav-scroll', this.handleScroll);
            if (elem) {
                const offsets = this.getHeaderOffset() + this.getNavOffset();
                const top = $(elem).offset().top - offsets;
                $('html, body').animate({scrollTop: top}, 600, 'swing', this.handleScrollComplete);
            } else {
                console.warn(`community-nav.vue - cannot find element with id of '${id}'`);
            }
        },
        handleHashchange(e) {
            if (typeof e === 'string') {
                this.previousHash = this.hashValue;
                this.hashValue = `#${e}`;
                window.history.pushState({}, this.title, `${window.location.pathname}#${e}`);
            } else {
                e.preventDefault();
                this.previousHash = this.hashValue;
                this.hashValue = window.location.hash;
            }
        },
        handleNavItemClick(requestedHash) {
            this.scrollTo(requestedHash);
            this.toggleAccordion(false);
        },
        handleScroll(data) {
            if (data !== this.hash) {
               this.handleHashchange(data);
            }
        },
        toggleAccordion(flag) {
            this.isMainAccordionOpen = typeof flag !== 'boolean'
                ? !this.isMainAccordionOpen
                : flag;
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/components/apps/community-nav.vue